export const Pagination = ({
  total,
  itemsPerPage,
  currentPage,
  paginate,
  lang,
}) => {
  const totalPages = Math.ceil(total / itemsPerPage) || 1; // Đảm bảo `totalPages` luôn có giá trị hợp lệ

  const indexOfFirstData = (currentPage - 1) * itemsPerPage + 1;
  const indexOfLastData = Math.min(currentPage * itemsPerPage, total);

  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <p>
        {lang["show"]} {indexOfFirstData}-{indexOfLastData} {lang["of"]} {total}{" "}
        {lang["results"]}
      </p>
      <nav aria-label="Page navigation example">
        <ul className="pagination mb-0">
          {/* Nút quay về trang đầu */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => paginate(1)}>
              &#8810;
            </button>
          </li>

          {/* Nút trang trước */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => paginate(Math.max(1, currentPage - 1))}
            >
              &laquo;
            </button>
          </li>

          {/* Hiển thị trang trước, trang hiện tại và trang kế tiếp */}
          {currentPage > 2 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {Array.from({ length: totalPages }).map((_, index) => {
            if (
              index + 1 === currentPage ||
              (index + 1 >= currentPage - 1 && index + 1 <= currentPage + 1)
            ) {
              return (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              );
            }
            return null;
          })}

          {currentPage < totalPages - 1 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {/* Nút trang kế */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
            >
              &raquo;
            </button>
          </li>

          {/* Nút đi tới trang cuối */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={() => paginate(totalPages)}>
              &#8811;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};
